import GooglePhotosProcessor from "../../frontend/js/EventgalleryGooglePhotosProcessor";
import PhotoSwipeGallery from "../../frontend/js/photoswipe/PhotoSwipeGallery";

(function(Eventgallery) {
    "use strict";
    document.addEventListener('DOMContentLoaded', () => {

        let googlePhotosProcessor = new GooglePhotosProcessor();
        googlePhotosProcessor.processImages();

        /**
         * Lightbox init
         * @type {PhotoSwipeGallery}
         */
        Eventgallery.lightbox = new PhotoSwipeGallery();
        Eventgallery.lightbox.initPhotoSwipe();
    });
})(window.Eventgallery);

